module.exports = __webpack_public_path__ + "img/stats.566b1c3.png";